import React, { useEffect, useState } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import api from '../../services/api';

export default function DepartmentsPositions() {
  const [departments, setDepartments] = useState([]);
  const [positions, setPositions] = useState([]);
  const [newDepartment, setNewDepartment] = useState('');
  const [newPosition, setNewPosition] = useState('');

  const fetchAll = async () => {
    const [deptRes, posRes] = await Promise.all([
      api.get('/departments'),
      api.get('/positions'),
    ]);
    setDepartments(deptRes.data);
    setPositions(posRes.data);
  };

  useEffect(() => {
    fetchAll();
  }, []);

  const handleAddDepartment = async () => {
    if (!newDepartment.trim()) return;
    await api.post('/departments', { name: newDepartment });
    setNewDepartment('');
    fetchAll();
  };

  const handleAddPosition = async () => {
    if (!newPosition.trim()) return;
    await api.post('/positions', { name: newPosition });
    setNewPosition('');
    fetchAll();
  };

  const deleteDepartment = async (id) => {
    await api.delete(`/departments/${id}`);
    fetchAll();
  };

  const deletePosition = async (id) => {
    await api.delete(`/positions/${id}`);
    fetchAll();
  };

  const actionBodyTemplateDept = (rowData) => (
    <Button icon="pi pi-trash" className="p-button-danger" onClick={() => deleteDepartment(rowData.id)} />
  );

  const actionBodyTemplatePos = (rowData) => (
    <Button icon="pi pi-trash" className="p-button-danger" onClick={() => deletePosition(rowData.id)} />
  );

  return (
    <div className="grid p-4">
      <div className="col-12 md:col-6">
        <h3>Departmanlar</h3>
        <div className="p-inputgroup mb-3">
          <InputText
            placeholder="Yeni departman adı"
            value={newDepartment}
            onChange={(e) => setNewDepartment(e.target.value)}
          />
          <Button label="Ekle" icon="pi pi-plus" onClick={handleAddDepartment} />
        </div>
        <DataTable value={departments} paginator rows={5} stripedRows>
          <Column field="id" header="ID" />
          <Column field="name" header="Ad" />
          <Column header="Sil" body={actionBodyTemplateDept} />
        </DataTable>
      </div>

      <div className="col-12 md:col-6">
        <h3>Pozisyonlar</h3>
        <div className="p-inputgroup mb-3">
          <InputText
            placeholder="Yeni pozisyon adı"
            value={newPosition}
            onChange={(e) => setNewPosition(e.target.value)}
          />
          <Button label="Ekle" icon="pi pi-plus" onClick={handleAddPosition} />
        </div>
        <DataTable value={positions} paginator rows={5} stripedRows>
          <Column field="id" header="ID" />
          <Column field="name" header="Ad" />
          <Column header="Sil" body={actionBodyTemplatePos} />
        </DataTable>
      </div>
    </div>
  );
}
